var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15425_32886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8613 12.1601C12.4739 12.1601 13.7812 10.8528 13.7812 9.24023C13.7812 7.6276 12.4739 6.32031 10.8613 6.32031C9.2487 6.32031 7.94141 7.6276 7.94141 9.24023C7.94141 10.8528 9.2487 12.1601 10.8613 12.1601Z",
    stroke: "#242833",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6097 7.13309V13.309C20.6052 13.7661 20.51 14.2178 20.3297 14.6379C20.1494 15.058 19.8876 15.4381 19.5593 15.7563L17.1121 18.2035L13.3729 21.9427C12.7511 22.5462 11.9248 22.8933 11.0585 22.9147C10.1923 22.9361 9.34978 22.6303 8.69896 22.0582L4.59217 18.4766L2.55454 16.6701C2.1891 16.3459 1.89631 15.9481 1.69539 15.5028C1.49447 15.0575 1.38994 14.5748 1.38867 14.0863V7.35365C1.39196 6.70753 1.57689 6.07535 1.92234 5.52932C2.26779 4.98329 2.75984 4.54541 3.34228 4.26569L9.44469 1.37729C9.88464 1.17399 10.362 1.06434 10.8466 1.0553C11.3312 1.04626 11.8123 1.13802 12.2596 1.32477L18.488 3.96109C19.1165 4.21958 19.6539 4.65925 20.0317 5.22412C20.4095 5.78899 20.6107 6.45351 20.6097 7.13309Z",
    stroke: "#242833",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1537 18.1984L13.4146 21.9375C12.7906 22.5531 11.9556 22.9076 11.0794 22.9291C10.2033 22.9506 9.35188 22.6373 8.69858 22.0531L4.5918 18.4715C5.41046 17.5956 6.40356 16.901 7.50709 16.4325C8.61062 15.9639 9.80008 15.7318 10.9988 15.7511C13.2936 15.7196 15.5071 16.5997 17.1537 18.1984V18.1984Z",
    stroke: "#242833",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15425_32886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3217,
    height: 24,
    fill: "white",
    transform: "translate(0.337891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsole);
export default __webpack_public_path__ + "static/media/console.9963d7b5d990b407aa43e98498faf9f8.svg";
export { ForwardRef as ReactComponent };